import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { jobArchitectureKeys } from './query-keys';

export const useInvalidateArchitecture = (): ((architectureId: string) => void) => {
    const queryClient = useQueryClient();

    return useCallback(
        (architectureId: string) => {
            void queryClient.invalidateQueries({ queryKey: jobArchitectureKeys.architecture(architectureId) });
        },
        [queryClient],
    );
};
